
import { get, post } from '../utils/http'

export const fetchSbtTemplates = () => (get('TEMPLATES_SBT_FETCH', '/admin/lawreports/templates/list'))
export const fetchNewsletterTemplates = () => (get('TEMPLATES_NEWSLETTER_FETCH', '/admin/newsletter/templates/list'))

export const editSbtTemplate = (payload) => ({ type: 'TEMPLATES_SBT_EDIT', payload })
export const editNewsletterTemplate = (payload) => ({ type: 'TEMPLATES_NEWSLETTER_EDIT', payload })

export const cancelSbtTemplateEdit = () => ({type: 'TEMPLATES_SBT_EDIT_CANCEL' })
export const cancelNewsletterTemplateEdit = () => ({type: 'TEMPLATES_NEWSLETTER_EDIT_CANCEL' })

export const deleteSbtTemplate = (id) => {
  
  let form = new FormData();
  form.append('id', id);
  return post('TEMPLATES_SBT_DELETE', '/admin/lawreports/templates/delete', form);
};

export const deleteNewsletterTemplate = (id) => {
  
  let form = new FormData();
  form.append('id', id);
  return post('TEMPLATES_NEWSLETTER_DELETE', '/admin/newsletter/templates/delete', form);
};

export const saveSbtTemplate = (template) => {

  let attributes = ['id', 'name', 'originalFileName', 'sourceId', 'documentSource', 'decisionDateString', 'preamble', 'content'];
  let form = new FormData();

  attributes.forEach(a => form.append(a, template[a] || ''));
    
  return post('TEMPLATES_SBT_SAVE', '/admin/lawreports/templates/update', form);
}

export const saveNewsletterTemplate = (template) => {

  let attributes = ['id', 'title', 'dbType', 'header', 'footer'];
  let form = new FormData();

  attributes.forEach(a => form.append(a, template[a] || ''));
    
  return post('TEMPLATES_NEWSLETTER_SAVE', '/admin/newsletter/templates/update', form);
}

export const templateSbtEditAttr = (attr, value) => ({type:'TEMPLATES_SBT_ATTR_EDIT', payload: {attr, value}});

export const templateNewsletterEditAttr = (attr, value) => ({type:'TEMPLATES_NEWSLETTER_ATTR_EDIT', payload: {attr, value}});

export const onChangeTab = (activeKey) => ({ type: 'TEMPLATES_CHANGE_TAB', payload: activeKey })



// WEBPACK FOOTER //
// ./src/templates/templateActions.js